import {Request} from '@/apis'

export function list() {
    return Request.get("/message/list", {});
}

export function read(id) {
    return Request.post("/message/read", {id: id});
}
